module.exports = __webpack_public_path__ + "media/images/application/template/arrow-right-129c65aba9c6957826f874459f0eec34.png";